import * as caniuse from 'caniuse-lite';
import {
  browserVersion,
  isAndroid,
  isChrome,
  isChromium,
  isEdge,
  isEdgeChromium,
  isFirefox,
  isMobileSafari,
  isSafari,
} from 'react-device-detect';

const getBrowserKey = () => {
  if (isMobileSafari) {
    return 'ios_saf';
  }

  if (isAndroid) {
    return 'android';
  }

  if (isChrome || isChromium || isEdgeChromium) {
    return 'chrome';
  }

  if (isFirefox) {
    return 'firefox';
  }

  if (isSafari) {
    return 'safari';
  }

  if (isEdge) {
    return 'edge';
  }

  return 'ie';
};

const getBrowserData = () => {
  const browserVersionNum = !isNaN(Number(browserVersion))
    ? Number(browserVersion)
    : null;

  return {
    browserName: getBrowserKey(),
    browserVersion: browserVersionNum,
  };
};

export const getBrowserSupport = (attribute: string) => {
  const browserData = getBrowserData();

  if (!browserData.browserVersion) {
    return false;
  }

  const packedFeature = caniuse.features[attribute];

  if (!packedFeature) {
    return false;
  }

  const feature = caniuse.feature(packedFeature);

  if (!feature) {
    return false;
  }

  const stat = feature.stats[browserData.browserName];

  if (!stat) {
    return false;
  }

  return stat[browserData.browserVersion] === 'y';
};
